import { Component, input } from "@angular/core";
import { RouterModule } from "@angular/router";
import { TranslatePipe } from "@ngx-translate/core";

import { TranslateTokenPipe } from "../../../../core/pipes";
import { AdaaHelper } from "../../../../core/utils";
import { Constants } from "../../../constants/constants";
import { SDGModelType } from "../../../models";
import { DoughnutComponent } from "../../charts";

@Component({
  selector: "adaa-sdg-circle",
  imports: [TranslateTokenPipe, DoughnutComponent, TranslatePipe, RouterModule],
  templateUrl: "./sdg-circle.html",
  styleUrl: "./sdg-circle.scss",
})
export class SdgCircleComponent {
  sdgModel = input.required<SDGModelType | undefined>();

  adaaHelper = AdaaHelper;
  constants = Constants;
  tooltip: number | undefined = undefined;
}
